module.exports = __webpack_public_path__ + "static/ITMOD_915virtual-bf19e076268d40df98b04666dc305d78.png";